import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { BaseServicesService } from 'src/app/services/base-services/base-services.service';
import { LoggingService } from 'src/app/services/consoleLogs';

const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';

@Component({
  selector: 'app-full',
  templateUrl: './full.component.html',
  styleUrls: ['./full.component.scss'],
})
export class FullComponent implements OnInit {

  @ViewChild('leftsidenav')
  public sidenav: MatSidenav | any;
  isCollapsed = false; 
  //get options from service
  private layoutChangesSubscription = Subscription.EMPTY;
  private isMobileScreen = false;
  private isContentWidthFixed = true;
  private isCollapsedWidthFixed = false;
  private htmlElement!: HTMLHtmlElement;
  collapseSubscription!: Subscription;
  expandSubscription!: Subscription;

  get isOver(): boolean {
    return this.isMobileScreen;
  }

  constructor(private breakpointObserver: BreakpointObserver,private router: Router,private basesService: BaseServicesService,private loggingservice:LoggingService) {
    this.htmlElement = document.querySelector('html')!;
    this.layoutChangesSubscription = this.breakpointObserver
      .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW])
      .subscribe((state) => {
        // SidenavOpened must be reset true when layout changes

        this.isMobileScreen = state.breakpoints[MOBILE_VIEW];

        this.isContentWidthFixed = state.breakpoints[MONITOR_VIEW];
      });
  }

  isSidenavVisible! : boolean; 
  routerSubscription!: Subscription;

  ngOnInit() {
    this.checkSidenavVisibility();

    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.checkSidenavVisibility();
      }
    });

    // Listen for collapse signal
    this.collapseSubscription = this.basesService.collapseSidenav$.subscribe(() => {
      if (this.sidenav.opened) {
        this.sidenav.close();
      }
    });
    this.expandSubscription = this.basesService.expandSidenav$.subscribe(() => {
      this.loggingservice.log('🔁 Expand sidenav triggered');
      if (!this.sidenav.opened) {
        this.isContentWidthFixed = true;
        this.isCollapsedWidthFixed = true;
        this.sidenav.open(); // ✅ This will now trigger (openedChange)
      }
    });
    
    
  
  }


  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    this.layoutChangesSubscription.unsubscribe();
    this.collapseSubscription?.unsubscribe();
    this.expandSubscription?.unsubscribe();
  }
  checkSidenavVisibility() {
    
    // Check if the current URL matches the desired route
    if (this.router.url === '/lms/admin/news') {
      this.isSidenavVisible = true;
      this.loggingservice.log('Sidenav visible:', this.isSidenavVisible);
    } else {
      this.isSidenavVisible = false;
    }
  }
  toggleCollapsed(): void {

    this.isCollapsed = !this.isCollapsed;
  }
  
  // New method to handle mobile vs desktop toggle
  handleMobileNavToggle(): void {

    if (this.isOver) {
  
      this.sidenav.toggle();
    } else {
      this.toggleCollapsed();
    }
  }

  onSidenavClosedStart() {
    this.loggingservice.log("asd4")
    this.isContentWidthFixed = false;
  }

  onSidenavOpenedChange(isOpened: boolean) {
    this.loggingservice.log("asd3")
    this.isCollapsedWidthFixed = !this.isOver;
  }
}
